﻿import axios from 'config/axios';

export default class NoteService {
  static async add(payload) {
    const { data } = await axios.post('notes/', payload);
    return data;
  }
}
